<template>
  <div
    :id="id"
    class="cs-dd"
  >
    <div
      @click.capture="show = !show"
      class="cs-dd__btn"
    >
      <div class="cs-dd__info cs-info">
        <div class="cs-info__title">
          <div class="cs-info__total d-flex" v-if="data.cart && data.cart.length">
            <div>{{ $t('unauth-payment.order-details') }}</div>
            <div class="cs-info__total-items">
              ({{ data.cart.length}} {{$t('unauth-payment.items')}})
            </div>
          </div>
        </div>
        <div>
          <div class="cs-info__amount">
            <span class="cs-info__amount-total">{{ $t('unauth-payment.total') }} </span>
            {{
              NumberFormat(
                DecimalNumber(data.amount)
                  .mul(data.conversionRate !== undefined ? data.conversionRate : 1),
                2)
            }} {{ data.displayCurrency !== undefined
              ? data.displayCurrency : $t('unauth-payment.usd') }}
          </div>
          <div
            v-if="isSubscription"
            class="cs-info__subscription">
            Subscription Included
          </div>
        </div>
        <div class="cs-dd__arrow">
          <img src="@/assets/img/arrow.svg" alt="arrow">
        </div>
      </div>
    </div>

    <b-collapse
      :id="`collapse-${id}`"
      v-model:open="show"
      class="cs-dd__options"
    >
      <!-- <vue-scroll
        v-if="data.cart && data.cart.length > 3"
        class="cs-dd__scroll"
        :ops="scrollOptions"
      > -->
      <div  v-if="data.cart && data.cart.length > 3">
        <div
          v-for="(item, i) in data.cart"
          
          :key="i"
          class="cs-dd__option cs-option"
        >
          <div class="cs-option__left">
            <div class="cs-option__name">
              <p>{{ item.name }}</p>
            </div>
            <span
              v-if="item.quantity > 1"
              class="cs-option__name_small"
            >
              {{ `x${item.quantity}` }}
            </span>
          </div>
          <div class="cs-option__right">
            <div class="cs-option__amount">

              {{ NumberFormat(
                DecimalNumber(item.price)
                  .mul(item.quantity)
                  .mul(data.conversionRate !== undefined ? data.conversionRate : 1),
                2) }}
              {{ data.displayCurrency !== undefined
                ? data.displayCurrency : $t('unauth-payment.usd')}}
            </div>
            <div
              v-if="item.frequency"
              class="cs-option__frequency">
              /{{item.frequency}}
            </div>
          </div>
        </div>
        </div>
      <!-- </vue-scroll> -->
      <div v-else>
        <div
          v-for="(item, i) in data.cart"
          :key="i"
          class="cs-dd__option cs-option"
        >
          <div class="cs-option__left">
            <div class="cs-option__name">
              <p>{{ item.name }}</p>
            </div>
            <span
              v-if="item.quantity > 1"
              class="cs-option__name_small"
            >
              {{ `x${item.quantity}` }}
            </span>
          </div>
          <div class="cs-option__right">
            <div class="cs-option__amount">
              {{ NumberFormat(
                DecimalNumber(item.price)
                  .mul(item.quantity)
                  .mul(data.conversionRate !== undefined ? data.conversionRate : 1),
                2) }}
              {{ data.displayCurrency !== undefined
                ? data.displayCurrency : $t('unauth-payment.usd')}}
            </div>
            <div
              v-if="item.frequency"
              class="cs-option__frequency">
              /{{ item.frequency }}
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>
<script>

export default {
  props: {
    id: String,
    data: Object,
    displayCurrency: Object,
  },
  data: () => ({
    scrollOptions: {
      scrollPanel: {
        scrollingX: false,
      },
      rail: {
        opacity: 0,
        size: '3px',
        gutterOfSide: 0,
        keepShow: false,
      },
      bar: {
        background: '#202A44',
        keepShow: true,
        size: '3px',
      },
    },
    show: false,
  }),
  computed: {
    isSubscription() {
      if (this.data && this.data.cart && this.data.cart.length) {
        const subs = this.data.cart.some((el) => el.isSubscription);
        return subs;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.cs-dd {
  position: relative;
  height: auto;
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 15px;

  &__btn {
    cursor: pointer;
    background: #F3F3F3;
    // border: 1px solid $border;
    width: 100%;
    height: 55px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    outline: none;
    border-radius: 4px;
    &.not-collapsed {
      & .cs-dd__arrow {
        transform: rotate(180deg);
      }
    }
  }

  &__arrow {
    width: 20px;
    min-width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .35s;
  }

}

.cs-option {
  background: $white;
  border: 1px solid #DADADA;
  // border-top: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 13px;
  transition: .3s;
  // border-radius: 0 0 4px 4px;

  &__left {
    display: flex;
    align-items: center;
    width: 205px;
  }

  &__name {
    font-weight: 500;
    font-size: 16px;
    line-height: 27px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-width: 200px;
    word-wrap: break-word;
    p {
      margin: 0;
    }
    &_small {
      font-weight: 300;
      font-size: 14px;
      line-height: 16px;
      color: $black400;
    }
  }

  &__right {
    display: flex;
    // flex-direction: column;
    align-items: flex-end;
    margin-left: 15px;
  }

  &__amount {
    font-size: 14px;
    line-height: 18px;
    font-weight: 900;
    white-space: nowrap;
    margin-right: 2px;
  }

  &__frequency {
    color: #5559FE;
    font-size: 12px;
    font-weight: 900;
  }

  &__convert {
    font-weight: 300;
    font-size: 14px;
    line-height: 23px;
    color: $black400;
    margin-top: 2px;
  }
}

.cs-option:nth-child(even) {
  border-top: none;
  border-bottom: none;
}

.cs-dd__scroll {
  height: 174px !important;
}

.cs-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &__title {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__total {
    font-size: 16px;
    line-height: 18px;
    margin-right: 5px;
    font-weight: 700;
    flex-wrap: wrap;
    &-items{
      color: #888786;
      font-size: 14px;
      font-weight: normal;
    }
  }

  &__amount {
    float: right;
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
    white-space: nowrap;
    &-total{
      color: #888786;
      font-size: 14px;
      font-weight: normal;
    }
  }

  &__subscription {
    color: #5559FE;
    font-size: 10px;
    white-space: nowrap;
    margin-top: 21px;
    font-weight: 700;
  }

  &__convert {
    font-weight: 300;
    color: $black400;
    font-size: 14px;
    line-height: 16px;
    margin-top: 3px;
  }

  &__items {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #7e8197;
    // margin-left: auto;
    // margin-right: 10px;
  }

  &__name {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
